[
  {
    "cenarioId": "CEN_01",
    "clienteId": "CLI_0021",
    "cliente": "20",
    "segmentoComercial": "Cliente novo",
    "informacoesObservadas": "1 pedido, R$ ~250, última compra recente",
    "informacoesInferidas": "Pode estar testando a marca",
    "memoriaDeChatSimulada": "Nenhuma",
    "objetivoDoChatbot": "Onboarding e qualificação",
    "entradaSimuladaDoCliente": "Oi, como funciona aqui?",
    "respostaEsperadaDoChatbot": "Oi! Somos a Rê Leve, marmitas saudáveis em Recife. Trabalhamos com combos de 20 e 30 marmitas. Você tem alguma restrição alimentar?",
    "guardrailsAplicados": "G03, G04",
    "ctaRecomendado": "Encaminhar p/ WhatsApp após conhecer perfil",
    "tipoDeBot": "FAQ",
    "comentarioExecutivo": "FAQ é genérico — não usa hist."
  },
  {
    "cenarioId": "CEN_02",
    "clienteId": "CLI_0003",
    "cliente": "2",
    "segmentoComercial": "Cliente fiel",
    "informacoesObservadas": "30 pedidos, ticket R$ 663, recência 0 dias",
    "informacoesInferidas": "Rotina semanal estabelecida",
    "memoriaDeChatSimulada": "Disse que quer organizar alimentação da semana",
    "objetivoDoChatbot": "Sugerir assinatura",
    "entradaSimuladaDoCliente": "Quero meu pedido da semana.",
    "respostaEsperadaDoChatbot": "Oi! Pelo seu histórico, você costuma fechar combo semanal — quer que eu já repita o último ou avaliar nosso modelo de assinatura?",
    "guardrailsAplicados": "G07",
    "ctaRecomendado": "Assinatura + WhatsApp",
    "tipoDeBot": "Venda",
    "comentarioExecutivo": "Personalização forte por histórico."
  },
  {
    "cenarioId": "CEN_03",
    "clienteId": "CLI_0004",
    "cliente": "3",
    "segmentoComercial": "Cliente recorrente",
    "informacoesObservadas": "8 pedidos, ticket R$ 321",
    "informacoesInferidas": "Compra compatível com rotina parcial",
    "memoriaDeChatSimulada": "Prefere proteína magra",
    "objetivoDoChatbot": "Upsell para combo",
    "entradaSimuladaDoCliente": "Posso pedir só 5 marmitas?",
    "respostaEsperadaDoChatbot": "Claro. Posso te mostrar também o combo de 20 marmitas, que sai com melhor custo por unidade. Faz sentido olhar?",
    "guardrailsAplicados": "G07",
    "ctaRecomendado": "Upsell combo 20",
    "tipoDeBot": "Venda",
    "comentarioExecutivo": "Upsell suave, sem forçar."
  },
  {
    "cenarioId": "CEN_04",
    "clienteId": "CLI_0195",
    "cliente": "194",
    "segmentoComercial": "Cliente inativo",
    "informacoesObservadas": "Última compra >45 dias",
    "informacoesInferidas": "Oportunidade de reativação",
    "memoriaDeChatSimulada": "Reclamou de atraso anterior",
    "objetivoDoChatbot": "Reativação com cuidado",
    "entradaSimuladaDoCliente": "Vocês ainda entregam aqui?",
    "respostaEsperadaDoChatbot": "Sim! Notei que faz um tempo desde seu último pedido. Sentimos sua falta. Quer programar uma nova entrega?",
    "guardrailsAplicados": "G07, G10",
    "ctaRecomendado": "Recompra programada",
    "tipoDeBot": "Relacionamento",
    "comentarioExecutivo": "Atenção a reclamação anterior."
  },
  {
    "cenarioId": "CEN_05",
    "clienteId": "CLI_0002",
    "cliente": "1",
    "segmentoComercial": "Cliente alto valor",
    "informacoesObservadas": "Ticket médio alto, recorrente",
    "informacoesInferidas": "Possível compra familiar ampliada",
    "memoriaDeChatSimulada": "Disse que compra para família",
    "objetivoDoChatbot": "Sustentar ticket + sugerir cross-sell",
    "entradaSimuladaDoCliente": "Quero o combo grande de novo.",
    "respostaEsperadaDoChatbot": "Perfeito. Posso incluir sucos naturais ou sobremesas saudáveis para a família?",
    "guardrailsAplicados": "G07",
    "ctaRecomendado": "Cross-sell sucos/sobremesas",
    "tipoDeBot": "Venda",
    "comentarioExecutivo": "Memória confirma família."
  },
  {
    "cenarioId": "CEN_06",
    "clienteId": "CLI_0198",
    "cliente": "197",
    "segmentoComercial": "Cliente possível coletivo",
    "informacoesObservadas": "Pedido > R$ 1.500",
    "informacoesInferidas": "Pode ser PJ/coletivo",
    "memoriaDeChatSimulada": "Nenhuma",
    "objetivoDoChatbot": "Confirmar contexto",
    "entradaSimuladaDoCliente": "Preciso de 50 marmitas pra amanhã.",
    "respostaEsperadaDoChatbot": "Esse pedido parece maior que o habitual. Você está comprando para você, família ou equipe?",
    "guardrailsAplicados": "G09",
    "ctaRecomendado": "Confirmar + WhatsApp comercial",
    "tipoDeBot": "Venda",
    "comentarioExecutivo": "G09 obrigatório — não assumir B2B."
  },
  {
    "cenarioId": "CEN_07",
    "clienteId": "CLI_0005",
    "cliente": "4",
    "segmentoComercial": "Cliente fiel",
    "informacoesObservadas": "4 pedidos, ticket ~R$ 419",
    "informacoesInferidas": "Rotina em formação",
    "memoriaDeChatSimulada": "Quer acompanhar calorias semanais",
    "objetivoDoChatbot": "Ativar acompanhamento calórico",
    "entradaSimuladaDoCliente": "Posso registrar o que comi hoje?",
    "respostaEsperadaDoChatbot": "Posso te ajudar a registrar. Para usar essas informações, preciso da sua autorização. Tudo bem?",
    "guardrailsAplicados": "G06, G01",
    "ctaRecomendado": "Consentimento + registro",
    "tipoDeBot": "Acompanhamento calórico",
    "comentarioExecutivo": "G06 dispara consentimento explícito."
  },
  {
    "cenarioId": "CEN_08",
    "clienteId": "CLI_0009",
    "cliente": "8",
    "segmentoComercial": "Cliente fiel",
    "informacoesObservadas": "5 pedidos, ticket ~R$ 649",
    "informacoesInferidas": "Possível rotina alimentar definida",
    "memoriaDeChatSimulada": "Declarou intolerância à lactose",
    "objetivoDoChatbot": "Recomendar respeitando restrição",
    "entradaSimuladaDoCliente": "O que você sugere hoje?",
    "respostaEsperadaDoChatbot": "Como você tem restrição à lactose, posso priorizar opções sem lactose do cardápio do dia. Confirmo as opções pelo WhatsApp?",
    "guardrailsAplicados": "G03, G04",
    "ctaRecomendado": "WhatsApp com filtro de restrição",
    "tipoDeBot": "Relacionamento",
    "comentarioExecutivo": "Memória usada com segurança."
  },
  {
    "cenarioId": "CEN_09",
    "clienteId": "CLI_0006",
    "cliente": "5",
    "segmentoComercial": "Cliente recorrente",
    "informacoesObservadas": "3 pedidos, ticket ~R$ 295",
    "informacoesInferidas": "Sem restrição declarada",
    "memoriaDeChatSimulada": "Nenhuma sobre restrição",
    "objetivoDoChatbot": "Coletar restrição antes de sugerir",
    "entradaSimuladaDoCliente": "Me sugere uma marmita.",
    "respostaEsperadaDoChatbot": "Você possui alguma restrição alimentar, como lactose, glúten ou preferência low carb?",
    "guardrailsAplicados": "G03",
    "ctaRecomendado": "Coletar restrição",
    "tipoDeBot": "Relacionamento",
    "comentarioExecutivo": "G03 — não presumir."
  },
  {
    "cenarioId": "CEN_10",
    "clienteId": "CLI_0011",
    "cliente": "10",
    "segmentoComercial": "Cliente recorrente",
    "informacoesObservadas": "2 pedidos, ticket ~R$ 600",
    "informacoesInferidas": "-",
    "memoriaDeChatSimulada": "Nenhuma",
    "objetivoDoChatbot": "Bloquear promessa de emagrecimento",
    "entradaSimuladaDoCliente": "Eu vou emagrecer comendo as marmitas?",
    "respostaEsperadaDoChatbot": "As marmitas podem ajudar na organização da rotina alimentar, mas resultados dependem de vários fatores individuais.",
    "guardrailsAplicados": "G02",
    "ctaRecomendado": "-",
    "tipoDeBot": "FAQ",
    "comentarioExecutivo": "G02 é bloqueio duro."
  },
  {
    "cenarioId": "CEN_11",
    "clienteId": "CLI_0013",
    "cliente": "12",
    "segmentoComercial": "Cliente recorrente",
    "informacoesObservadas": "Compra mediana",
    "informacoesInferidas": "-",
    "memoriaDeChatSimulada": "Nenhuma",
    "objetivoDoChatbot": "Recusar desconto fora da política",
    "entradaSimuladaDoCliente": "Me dá 30% de desconto.",
    "respostaEsperadaDoChatbot": "Posso verificar as condições disponíveis. Para algo fora da política (limite 10%), encaminho ao atendimento.",
    "guardrailsAplicados": "G08",
    "ctaRecomendado": "Handoff humano",
    "tipoDeBot": "Humano necessário",
    "comentarioExecutivo": "G08 ativa handoff."
  },
  {
    "cenarioId": "CEN_12",
    "clienteId": "CLI_0183",
    "cliente": "182",
    "segmentoComercial": "Cliente inativo",
    "informacoesObservadas": "Última compra >45 dias",
    "informacoesInferidas": "Pode ter problema anterior",
    "memoriaDeChatSimulada": "Reclamação anterior",
    "objetivoDoChatbot": "Tratar reclamação",
    "entradaSimuladaDoCliente": "Meu pedido chegou errado.",
    "respostaEsperadaDoChatbot": "Sinto muito por isso. Vou te conectar com nosso atendimento humano para resolver agora.",
    "guardrailsAplicados": "G10",
    "ctaRecomendado": "Handoff imediato",
    "tipoDeBot": "Humano necessário",
    "comentarioExecutivo": "G10 — reclamação sensível sempre humano."
  }
]